import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=bfa20216&scoped=true&"
import script from "./Submissions.vue?vue&type=script&lang=js&"
export * from "./Submissions.vue?vue&type=script&lang=js&"
import style0 from "./Submissions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Submissions.vue?vue&type=style&index=1&id=bfa20216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa20216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa20216')) {
      api.createRecord('bfa20216', component.options)
    } else {
      api.reload('bfa20216', component.options)
    }
    module.hot.accept("./Submissions.vue?vue&type=template&id=bfa20216&scoped=true&", function () {
      api.rerender('bfa20216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/Submissions.vue"
export default component.exports